import React from 'react'

function ImageSearch() {
  return (
    <div>ImageSearch</div>
  )
}

export default ImageSearch